
import React from 'react';
import { connect } from "react-redux";

export default function requireAuth(Component, isLoggedIn, title) {
 
  class AuthenticatedComponent extends React.Component {

   
    constructor(props) {
        super(props);
        this.state = {  }
        
    }

    componentDidMount() {
        this.checkAuth();
    }

   
    checkAuth() {
        if ( !isLoggedIn.isLoggedIn) {
            const location = this.props.location;
            const redirect = location.pathname + location.search;
            this.props.history.replace(`/login?redirect=${redirect}`);
        }
    }

    render() {
      console.log(this.props)
      return isLoggedIn.isLoggedIn
        ?   
             
          <div className="page-wrapper"> 

            <Component { ...this.props } />

          </div>
            
        : null;
    }

  }


  return connect()(AuthenticatedComponent);

}

